/* src/components/share-project-modal/share-project-modal.component.scss */
:host {
  display: block;
  height: var(--vwui-modal--max-height);
}
.owner {
  margin: -1.2rem 0 1.8rem 0;
}
.member {
  table-layout: auto;
  width: 100%;
  margin: 0 0 1.8rem 0;
}
.member__col--options,
.member__col--full-access {
  width: 1px;
  white-space: nowrap;
}
.add-row {
  display: table;
  table-layout: auto;
  width: 100%;
}
.add-row__input {
  display: table-cell;
  vertical-align: top;
  text-align: left;
}
.add-row__input--submit {
  width: 1px;
  white-space: nowrap;
  padding-left: 0.6rem;
}
/*# sourceMappingURL=share-project-modal.component-XPETZ4AF.css.map */
